export const SECTION_IDS = {
  TOP: 'top',
  ABOUT: 'about',
  DIGITAL: 'digital-promotion',
  MEDIA: 'media',
  CASE: 'case',
  RECRUIT: 'recruit',
  COMPANY: 'company',
  CONTACT: 'contact',
};
